(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[548],{

/***/ 7301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classic/[id]",
      function () {
        return __webpack_require__(5467);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ClassicPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _data_gameSchedule__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6601);
/* harmony import */ var _data_gameSchedule__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_data_gameSchedule__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_dateHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2536);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _data_animerdle_list_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8984);
/* harmony import */ var _utils_encryption__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(771);
/* harmony import */ var mailgo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5107);
/* harmony import */ var mailgo__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(mailgo__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2010);
/* harmony import */ var _components_guess_bars_CurrentBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6896);
/* harmony import */ var _components_guess_bars_FailedBar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1688);
/* harmony import */ var _components_guess_bars_SkipBar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2852);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9831);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_SectionContainer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(890);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1720);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);

















const DynamicPlayController = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 362).then(__webpack_require__.bind(__webpack_require__, 9362)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9362)
            ]
    }
});
function ClassicPage(param) {
    let { totalStats  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
    const { id  } = router.query;
    const animeList = _data_animerdle_list_json__WEBPACK_IMPORTED_MODULE_3__;
    const [todayAnime, setTodayAnime] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(null);
    const [soundUrl, setSoundUrl] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)("");
    let schedule = null;
    const updateThisAnime = (id)=>{
        schedule = (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_1___default())[id];
        if (schedule === undefined) {
            return;
        }
        let additionals = "";
        if (schedule.id !== undefined) {
            additionals = "_audio".concat(schedule.audioNum);
            schedule = schedule.id;
        }
        const _todayAnime = animeList.find((x)=>x.id === schedule);
        const audioName = "".concat(_todayAnime.id.toString());
        setTodayAnime(_todayAnime);
        setSoundUrl("../static/assets/anime/".concat((0,_utils_encryption__WEBPACK_IMPORTED_MODULE_14__/* .SHA1 */ .O)(audioName)).concat(additionals, ".mp3"));
        setIsDataReady(true);
    };
    const [currentGameStats, setCurrentGameStats] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)({
        day: (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_15__/* .getDayOfTheYear */ .c)(),
        malId: (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_1___default())[(0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_15__/* .getDayOfTheYear */ .c)()],
        actions: []
    });
    const resetCurrentGameStats = ()=>{
        setCurrentGameStats({
            day: (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_15__/* .getDayOfTheYear */ .c)(),
            malId: (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_1___default())[(0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_15__/* .getDayOfTheYear */ .c)()],
            actions: []
        });
    };
    const [currentAttemptNum, setCurrentAttemptNum] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(0);
    const [action, setAction] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)([
        ...Array("", "", "", "", "", "")
    ]);
    const [submittedAnime, setSubmittedAnime] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)([]);
    for(let i = 0; i < currentGameStats.actions.length; i++){
        if (currentGameStats.actions[i].skip) {
            action[i] = "skip";
        }
        if (currentGameStats.actions[i].failedGuess) {
            const anime = animeList.find((x)=>x.id === currentGameStats.actions[i].animeId);
            submittedAnime[i] = anime.title;
            action[i] = "failedguess";
        }
        if (currentGameStats.actions[i].win) {
            const anime1 = animeList.find((x)=>x.id === currentGameStats.actions[i].animeId);
            submittedAnime[i] = anime1.title;
            action[i] = "correctguess";
        }
    }
    const [isDataReady, setIsDataReady] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const mailgoConfig = {
        dark: true
    };
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(()=>{
        if (router.isReady && isNaN(Number(id))) {
            router.push("/");
        }
        if (router.isReady) {
            updateThisAnime(id);
            if (schedule === undefined) {
                router.push("/");
            }
        }
        mailgo__WEBPACK_IMPORTED_MODULE_16___default()(mailgoConfig);
    }, [
        router.isReady
    ]);
    const [win, setWin] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [finishedGame, setFinishedGame] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const finishedGameStateRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(finishedGame);
    const setFinishedGameState = (data)=>{
        finishedGameStateRef.current = data;
        setFinishedGame(data);
    };
    const [opaqueExceptPlay, setOpaqueExceptPlay] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const theme = (0,next_themes__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
    const resetToInitialState = ()=>{
        const temp = [
            ...Array("", "", "", "", "", "")
        ];
        setAction(temp);
        setCurrentAttemptNum(0);
        setSubmittedAnime([]);
        resetCurrentGameStats();
        setFinishedGameState(false);
    };
    const onSubmit = (anime)=>{
        if (todayAnime.id === anime.id) {
            // player won, show him finishedGame screen
            const temp = action;
            temp[currentAttemptNum] = "correctguess";
            setAction(temp);
            setFinishedGameState(true);
            setWin(true);
        } else {
            let temp1 = submittedAnime;
            temp1[currentAttemptNum] = anime.title;
            setSubmittedAnime(temp1);
            temp1 = action;
            temp1[currentAttemptNum] = "failedguess";
            setAction(temp1);
            updateAttempt();
            if (currentAttemptNum === 5) {
                setFinishedGameState(true);
            }
        }
    };
    const onSkip = ()=>{
        let temp = action;
        temp[currentAttemptNum] = "skip";
        setAction(temp);
        updateAttempt();
        if (currentAttemptNum === 5) {
            setFinishedGameState(true);
        }
    };
    const updateAttempt = ()=>{
        setCurrentAttemptNum(currentAttemptNum + 1);
    };
    // Render Guess Bars
    const renderResultBar = (barNum)=>{
        if (!action[barNum]) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_guess_bars_CurrentBar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                isSelected: currentAttemptNum === barNum
            });
        } else {
            if (action[barNum] === "failedguess") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_guess_bars_FailedBar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    failedGuess: submittedAnime[barNum]
                });
            }
            if (action[barNum] === "skip") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_guess_bars_SkipBar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_SEO__WEBPACK_IMPORTED_MODULE_8__/* .PageSEO */ .TQ, {
                title: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_9___default().shortTitle) + " - " + "Classic " + id,
                description: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_9___default().description),
                keywords: "anime guessing game, animerdle"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_SectionContainer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: "flex h-full flex-col justify-between",
                    children: isDataReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
                        children: [
                            finishedGame ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("main", {
                                className: "flex h-full flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                        "aria-label": "Go to today's anime guess site",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            href: "",
                                            className: "text-left",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                                className: "flex min-h-[9rem]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                                        className: "rounded-l",
                                                        src: todayAnime.image_url,
                                                        alt: "Today's Animerdle cover picture",
                                                        title: "Today's Animerdle cover picture",
                                                        width: 160,
                                                        height: 200
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                        className: "w-full rounded-md border-gray-700 bg-gray-300 p-5 dark:bg-gray-800",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                                            className: "flex h-full flex-col justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                                    className: "text-xl font-bold text-gray-800 dark:text-gray-200",
                                                                    children: todayAnime.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("p", {
                                                                    className: "text-sm text-gray-600 dark:text-gray-400",
                                                                    children: [
                                                                        "Type: ",
                                                                        todayAnime.type
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("p", {
                                                                    className: "text-sm text-gray-600 dark:text-gray-400",
                                                                    children: [
                                                                        "Status: ",
                                                                        todayAnime.status
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                        className: "flex flex-col gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                                                className: "flex justify-center font-bold",
                                                children: [
                                                    win && "You guessed the Animerdle!",
                                                    !win && "You didn't guess this Animerdle."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                                className: "flex justify-center text-sm text-gray-400",
                                                children: [
                                                    win && "Good job, you know your Anime.",
                                                    !win && "Better luck next time!"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("main", {
                                className: "flex h-full flex-col justify-between",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                    className: "relative flex flex-col justify-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                        className: "grid grid-cols-1 gap-2",
                                        children: [
                                            renderResultBar(0),
                                            renderResultBar(1),
                                            renderResultBar(2),
                                            renderResultBar(3),
                                            renderResultBar(4),
                                            renderResultBar(5)
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "".concat(opaqueExceptPlay && "absolute top-0 left-0 h-full w-full bg-black opacity-70")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(DynamicPlayController, {
                                onSubmit: onSubmit,
                                onSkip: onSkip,
                                currentAttemptNum: currentAttemptNum,
                                setCurrentAttemptNum: setCurrentAttemptNum,
                                updateAttempt: ()=>updateAttempt(),
                                finishedGameStateRef: finishedGameStateRef,
                                todayAnime: todayAnime,
                                setOpaqueExceptPlay: setOpaqueExceptPlay,
                                opaqueExceptPlay: opaqueExceptPlay,
                                currentGameStats: currentGameStats,
                                soundUrl: soundUrl
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                children: id
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,107,391,888,179], function() { return __webpack_exec__(7301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);